<template>
  <div class="wrapper"
    :class="{ 'pointer-events-none': !isShowing, 'is-active': isShowing }"
    @click.self="onBackdropClicked">
    <div class="bg-white">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShowing: false
    }
  },
  methods: {
    show () {
      this.isShowing = true
    },
    hide () {
      this.isShowing = false
    },
    toggle () {
      this.isShowing = !this.isShowing
    },
    onBackdropClicked () {
      if (this.isShowing) {
        this.$emit('backdrop-clicked')
      }
    }
  },
  watch: {
    isShowing (value) {
      if (value) {
        document.body.classList.add('zb-fixed-body')
        toggleTrengoChat({ show: false })
      }
      else {
        document.body.classList.remove('zb-fixed-body')
        toggleTrengoChat({ show: true })
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: background-color 0.5s ease;
  background-color: transparent;
}

.wrapper.is-active {
  background-color: #00000073;
}
</style>

<style>
.wrapper > * {
  transition: transform 0.5s;
  transform: translateY(120%);
}

.wrapper.is-active > * {
  transform: translateY(0%);
}
</style>
